import request from './request.js';

export const wxJSDK = (url) => {
  return request({
    url: `/api/blade-weixin/weiXinChat/jsapiTicket?url=${url}`,
    method: 'post'
  })
}

